import { isProduction } from '../environmentUtils';

import { getActiveExperiments, persistActiveExperiments } from './storage';

// This is the way we found to access experiments and variants IDs
// more info on: https://support.google.com/optimize/answer/9059383?hl=en
function gtag() {
  // eslint-disable-next-line prefer-rest-params, no-unused-expressions
  window.dataLayer?.push(arguments);
}

export function createPersistenceFn(saveExperiments, getExperiments) {
  return (variant, experimentId) => {
    const activeExperiments = getExperiments();
    const isExperimentOnStorage = Boolean(
      activeExperiments.find(exp => exp.experimentId === experimentId),
    );

    if (isExperimentOnStorage && isProduction()) return;

    saveExperiments({
      experiments: [
        ...activeExperiments.filter(exp => exp.experimentId !== experimentId),
        {
          experimentId,
          variant,
        },
      ],
    });
  };
}

export function createClearFn(saveExperiments) {
  return () => {
    saveExperiments({ experiments: [] });
  };
}
export const persistExperiments = createPersistenceFn(
  persistActiveExperiments,
  getActiveExperiments,
);

export const clearPersistedExperiments = createClearFn(persistActiveExperiments);

export function persistOptimizeActiveExperiments(callback = persistExperiments) {
  gtag('event', 'optimize.callback', { callback });
}
